import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';

import { BehaviorSubject, map, ReplaySubject, takeUntil } from 'rxjs';

import { UserStorage } from '@app/src/app/services/UserStorage';
import { getAppColor } from '@app/src/app/shared/constants';

import { AdminToolsMessages } from '../../../admin-tools/admin-tools.constant';
import { ToolsActionsService } from '../../../services/tools.actions.service';
import { ToolAction } from '../../types/shared-tools.types';

@Component({
  selector: 'mg-tools-actions-button',
  templateUrl: './tools-actions-button.component.html',
  styleUrls: ['./tools-actions-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolsActionsButtonComponent implements OnDestroy {
  // Constants

  public readonly MESSAGES = AdminToolsMessages;

  // Observables

  private readonly _destroyedSubject = new ReplaySubject<void>(1);

  public readonly favoriteActions$ = this._toolsActions.favoriteActions$;
  public readonly favoriteActionKeys$ = this.favoriteActions$.pipe(
    takeUntil(this._destroyedSubject),
    map(actions => actions.map(a => a.key)),
  );

  public assignActions = this._toolsActions.actions.filter(a => a.usedIn.includes('admin'));
  public ICON_COLORS = {
    assign: getAppColor('secondary-600'),
    points: getAppColor('warning-300'),
    kiosk: getAppColor('surface'),
  };

  // Component Constructor

  constructor(private _toolsActions: ToolsActionsService, private _localStorage: UserStorage) {}

  // Lifecycle Hooks

  ngOnDestroy(): void {
    this._destroyedSubject.next();
    this._destroyedSubject.complete();
  }

  // Public Methods

  public toggleFavoriteAction(option: ToolAction): void {
    this._toolsActions.toggleFavorite(option);
  }
}
